import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const assetRoutes = [
	{
		key: "asset",
		exact: true,
		path: `${APP_PREFIX_PATH}/asset-management`,
		component: React.lazy(() => import("views/app-views/asset-managements/asset/pages/AssetList")),
	},
	{
		key: "asset-add",
		exact: true,
		path: `${APP_PREFIX_PATH}/asset-management/add`,
		component: React.lazy(() => import("views/app-views/asset-managements/asset/pages/AssetCreate")),
	},
	{
		key: "asset-allocation",
		exact: true,
		path: `${APP_PREFIX_PATH}/asset-management/allocations`,
		component: React.lazy(() => import("views/app-views/asset-managements/allocation/pages/AllocationList")),
	},
	{
		key: "asset-service",
		exact: true,
		path: `${APP_PREFIX_PATH}/asset-management/service`,
		component: React.lazy(() => import("views/app-views/asset-managements/service/pages/ServiceList")),
	},
	{
		key: "asset-license",
		exact: true,
		path: `${APP_PREFIX_PATH}/asset-management/licenses`,
		component: React.lazy(() => import("views/app-views/asset-managements/license/pages/LicenseList")),
	},
	{
		key: "asset-disposal",
		exact: true,
		path: `${APP_PREFIX_PATH}/asset-management/disposal`,
		component: React.lazy(() => import("views/app-views/asset-managements/disposal/pages/DisposalList")),
	},
	{ 	key: "asset-type",
		path: `${APP_PREFIX_PATH}/asset-management/asset-type`, 
		component: React.lazy(() => import("views/app-views/asset-managements/asset-type/pages/AssetTypeList")) 
	},

	{ 	key: "brand", 
		path: `${APP_PREFIX_PATH}/asset-management/brand`, 
		component: React.lazy(() => import("views/app-views/asset-managements/brand/pages/BrandList")) 
	},

	// Opened by scanning an asset QR label (see components/AssetQrLabel.jsx)
	{
		key: "asset-scan",
		path: `${APP_PREFIX_PATH}/asset-scan/:assetNumber`,
		component: React.lazy(() => import("views/app-views/asset-managements/asset/pages/AssetScan")),
		meta: { blankLayout: true },
	},

	{ 	key: "upload-asset-list",
		path: `${APP_PREFIX_PATH}/asset-management/upload-asset-list`,
		component: React.lazy(() => import("views/app-views/asset-managements/asset/pages/AssetBulkAdd")),
	}
	
];
